import { useEffect, useState } from "react";
import { Toolbar } from "@/components/layout/Toolbar";
import { SplitPanel } from "@/components/layout/SplitPanel";
import { ErrorPanel } from "@/components/layout/ErrorPanel";
import { MapPreview } from "@/components/map/MapPreview";
import { EditorTabs } from "@/components/editor/EditorTabs";
import { useUndoRedo } from "@/hooks/useUndoRedo";
import { useStyleValidation } from "@/hooks/useStyleValidation";
import { useFileDropZone } from "@/hooks/useFileDropZone";
import { useEditorStore } from "@/store";
import { loadDefaultStyle } from "@/lib/defaultStyle";

export default function App() {
  const [loading, setLoading] = useState(true);
  const loadNewStyle = useEditorStore((s) => s.loadNewStyle);

  useEffect(() => {
    loadDefaultStyle().then((style) => {
      loadNewStyle(style);
      setLoading(false);
    });
  }, [loadNewStyle]);

  useUndoRedo();
  useStyleValidation();
  useFileDropZone();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center bg-surface-base">
        <div className="text-sm text-text-muted">Loading style...</div>
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col overflow-hidden bg-surface-base">
      <Toolbar />
      <div className="flex-1 overflow-hidden">
        <SplitPanel left={<MapPreview />} right={<EditorTabs />} />
      </div>
      <ErrorPanel />
    </div>
  );
}
